import { apiGet, apiPatch, apiPost } from "./client";

export async function createGenerationJob(body, signal) {
  return apiPost("/generations/jobs", body, signal);
}

export async function getGenerationJobStatus(jobId, signal) {
  return apiGet(`/generations/jobs/${encodeURIComponent(jobId)}`, { signal });
}

export async function listActiveGenerationJobs(signal) {
  return apiGet("/generations/jobs/active", { signal });
}

export async function getGenerationJobResult(jobId, signal) {
  return apiGet(`/generations/jobs/${encodeURIComponent(jobId)}/result`, { signal });
}

export async function updateGenerationJobPreferences(jobId, body, signal) {
  return apiPatch(
    `/generations/jobs/${encodeURIComponent(jobId)}/preferences`,
    body,
    signal,
  );
}

export async function cancelGenerationJob(jobId, signal) {
  return apiPost(`/generations/jobs/${encodeURIComponent(jobId)}/cancel`, {}, signal);
}
